<template>
  <div class="container main has-submenu" :class="{ fullwidth : !loggedIn }">
    <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="panel panel-info">
      <div class="wrapper">
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12 verification">
        <h2 class="font-size-normal"><i class="fa fa-envelope-o"></i> Email Verification </h2>
        <span class="font-size-normal text-success" v-if="emailVerify"><i class="fa fa-check"></i> Your email address was verified!</span>
        <template v-else>
            <div class="alert alert-info alert-dismissable">
                <a class="panel-close close" data-dismiss="alert">×</a>
                <i class="fa fa-exclamation-triangle" style="font-size: 20px; float: left; padding-right:5px"></i>
                Your <strong>email adress</strong> still not verified. Please use button to send verification email <strong>{{email}}</strong> to process account activation.
            </div>
          <vue-ladda :loading="loading" data-style="expand-right" @click="resetVerificationEmail">
              <i class="fa fa-reply"></i>
              <span> Send Verification Email</span>
          </vue-ladda>
        </template>
          <hr>
          <h2 class="font-size-normal"><i class="fa fa-mobile"></i> Mobile Verification </h2>
          <span class="font-size-normal text-success" v-if="phoneVerify"><i class="fa fa-check"></i> Your mobile number was verified!</span>
        <template v-else>
          <div class="alert alert-info alert-dismissable">
              <a class="panel-close close" data-dismiss="alert">×</a>
              <i class="fa fa-exclamation-triangle" style="font-size: 20px; float: left; padding-right:5px"></i>
              Click on button <strong>"Send SMS Code"</strong> to send verification code to your number <strong>{{phone}}</strong>
          </div>
          <form method="" @submit.prevent="verifySmsCode">
            <div class="form-group">
              <label class="control-label">SMS code:</label><br>
              <div class="col-lg-6">
                  <input class="form-control" v-model="smsCode" type="text" required="required">
              </div>
            </div>
            <br><br>
            <vue-ladda :loading="loading3" data-style="expand-right">
              <i class="fa fa-check"></i>
              <span> Verify SMS code</span>
            </vue-ladda>
          </form>
          <br>
          <vue-ladda :loading="loading2" type="button" data-style="expand-right" @click="resetVerificationPhone">
            <i class="fa fa-reply"></i>
            <span class="font-size-normal">Resend SMS Code</span>
          </vue-ladda>
        </template>
        </div>  <!-- end row -->
        </div>
      </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import {HTTP, account} from '../../services/account-services.js'
  import VueLadda from 'vue-ladda'
  import { default as swal } from 'sweetalert2'
  export default {
    name: 'EditProfile',
    components: {
      'vue-ladda': VueLadda
    },
    data() {
      return {
        email: localStorage.getItem('email'),
        phone: localStorage.getItem('phone'),
        smsCode: '',
        loading: false,
        loading2: false,
        loading3: false,
        emailVerify: false,
        phoneVerify: false
      }
    },
    methods: {
      checkIfAccountIsVerify() {
        let app = this
        account().then((response) => {
          app.emailVerify = response.emailVerified
          app.phoneVerify = response.phoneNumberVerified
        }).catch((e) => {
          console.error(e)
        })
      },
      resetVerificationEmail() {
        this.loading = true
        let token = localStorage.getItem('authToken')
        let userId = localStorage.getItem('userId')
        HTTP.post(`/accounts/${userId}/resetVerificationToken?access_token=${token}`, {
          id: userId,
          token: 'email'
        }).then((response) => {
          console.log(response)
          this.loading = false
          if (response.data.message === 'success') {
            swal(
              'Success',
              `A verification link has been send to ${this.email}. Please check your inbox.`,
              'success'
            )
          } else {
            swal(
              'Hoops',
              'An error has occurred please try again',
              'error'
            )
          }
        }).catch((e) => {
          console.log(e)
        })
      },
      resetVerificationPhone() {
        this.loading2 = true
        let token = localStorage.getItem('authToken')
        let userId = localStorage.getItem('userId')
        HTTP.post(`/accounts/${userId}/resetVerificationToken?access_token=${token}`,
          {
            id: userId,
            token: 'phoneNumber'
          }).then((response) => {
          console.log(response)
          if (response.data.message === 'success') {
            this.loading2 = false
            swal(
              'Success !',
              'A verification code has been send to ' + this.phone + ' Please check it out !',
              'success'
            )
          } else {
            this.loading2 = false
            swal(
              'Hoops !!',
              'An error has occurred please try again !',
              'error'
            )
          }
        }).catch((e) => {
          this.loading2 = false
          console.log(e)
        })
      },
      verifySmsCode() {
        this.loading3 = true
        let token = localStorage.getItem('authToken')
        let userId = localStorage.getItem('userId')
        console.log(this.smsCode)
        HTTP.post('/accounts/' + userId + '/verifyPhoneNumber?access_token=' + token,
          {
            id: userId,
            token: this.smsCode
          }).then((response) => {
          console.log(response)
          this.checkIfAccountIsVerify()
          if (response.data.success === true) {
            this.loading3 = false
            swal(
              'Success !',
              'Your phone number has been verified, thank you !!',
              'success'
            )
          } else {
            this.loading3 = false
            swal(
              'Hoops !!',
              'An error has occurred please try again !',
              'error'
            )
          }
        }).catch((e) => {
          this.loading3 = false
          console.log(e)
        })
      }
    },
    beforeMount() {
      if (!localStorage.getItem('authToken')) {
        return this.$router.push('/login')
      }
    },
    mounted() {
      this.checkIfAccountIsVerify()
    },
    props: ['loggedIn']
  }
</script>
<style scoped>
  .avatar{
    max-width: 60%;
  }
  .button {
    font-size:16px;
  }
 span {
    font-size:14px;
  }
.verification {
  padding-left: 10px;
  padding-right: 10px;
}
.ladda-button {
    background: #2bc0e4;
    border: 0;
    padding: 10px 18px;
    font-size: 18px;
    cursor: pointer;
    color: #fff;
    border-radius: 2px;
    border: 1px solid transparent;
    -webkit-appearance: none;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
}
.ladda-button:hover {
  background: #2873ac;
}
@media (max-width: 480px) {
  .ladda-button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Account/Verification.vue